var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['audio-icon-container', `${_vm.size == 'small' && 'small' }`]},[_c('div',{staticClass:"audio-level-container"},[_c('div',{staticClass:"audio-level",style:(_setup.audioLevelStyle)})]),_c(_setup.SvgIcon,{staticClass:"audio-icon",attrs:{"icon":_setup.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }